import { PROVIDERS, EXCLUDED_PROVIDERS } from './providers-listing'

export const nonProviders = [
  {
    id: 'im-not-sure',
    name: "I'm not sure",
    default: true
  },
  {
    id: 'i-dont-have-broadband',
    name: "I don't have broadband",
    default: true
  },
  {
    id: 'my-provider-is-not-listed',
    name: 'My provider is not listed',
    default: true
  }
]

export const getProviderNameFromId = (providersData, id) => {
  const currentProvider = providersData.find((data) => data.id === id) || nonProviders.find((data) => data.id === id)
  return currentProvider && currentProvider.name
}

export const getProviderIdFromName = (providersData, name) => {
  const currentProvider =
    providersData.find((data) => data.name === name) || nonProviders.find((data) => data.name === name)
  return currentProvider && currentProvider.id
}

export const filterExcludedProviders = (providersData, providersToExclude = EXCLUDED_PROVIDERS) =>
  providersData.filter((provider) => !providersToExclude.includes(provider.name))

export const getProvidersByScope = (providerList, scope) =>
  providerList.filter(({ services }) => services.includes(scope === 'broadband' ? 'BROADBAND' : 'TV'))

export const getProvidersByPageId = (pageId) =>
  pageId === 'business-broadband'
    ? PROVIDERS.filter(({ connectionTypes }) => connectionTypes.includes('BUSINESS'))
    : PROVIDERS.filter(({ connectionTypes }) => !connectionTypes.includes('BUSINESS'))

export const transformProvidersForDropdown = (providers) => {
  const groupedProviders = providers.reduce(
    (grouped, provider) => {
      const major = Boolean(provider.major)

      return {
        ...grouped,
        [major]: [...grouped[major], provider]
      }
    },
    { true: [], false: [] }
  )

  const compareProviders = (a, b) => {
    const aName = a.name.toUpperCase()
    const bName = b.name.toUpperCase()

    if (aName < bName) return -1
    if (aName > bName) return 1

    return 0
  }

  return groupedProviders.true
    ? [
        {
          title: 'Major providers',
          providers: groupedProviders.true.sort(compareProviders)
        },
        {
          title: 'Other providers',
          providers: groupedProviders.false.sort(compareProviders)
        },
        {
          providers: nonProviders
        }
      ]
    : [
        {
          providers
        },
        {
          providers: nonProviders
        }
      ]
}

export const PROVIDER_IDS = {
  TALKTALK: '12165',
  PLUSNET: '12185',
  BT: '12153',
  EE: '12763',
  SKY: '12175',
  VIRGIN: '12179',
  VODAFONE: '12193',
  NOW_BROADBAND: '12827',
  JOHN_LEWIS: '12746',
  SHELL_ENERGY_BROADBAND: '12833'
}
